import { useEffect } from 'react';

import { useAuth } from 'modules/auth/hooks/useAuth';
import { useChargingModel } from 'modules/billing/hooks/useChargingModel';
import { useGetUIProfileConfigQuery } from 'modules/common/actions/getUIProfileConfig';
import { useUpdateUIProfileConfigMutation } from 'modules/common/actions/updateUIProfileConfig';
import { useDialog } from 'modules/common/hooks/useDialog';
import { useAccount } from 'modules/account/hooks/useAccount';

export const useFreemiumWelcomeDialog = () => {
  const { isOpened, onClose, onOpen } = useDialog();
  const { isLoggedIn } = useAuth();

  const { group } = useAccount();

  const { data: config } = useGetUIProfileConfigQuery(
    { group },
    {
      skip: !isLoggedIn,
    },
  );

  const isHidden = !config || config.isFreemiumWelcomeDialogHidden;

  const chargingModel = useChargingModel();
  const isDefaultChargingModelUsed =
    chargingModel?.type === 'freemium' &&
    chargingModel.usage.leftPercent === 100;

  const [updateUIProfileConfig] = useUpdateUIProfileConfigMutation();

  const shouldBeOpened = isDefaultChargingModelUsed && !isHidden;

  useEffect(() => {
    if (shouldBeOpened) {
      onOpen();

      // once is opened should never be shown again
      updateUIProfileConfig({ group, isFreemiumWelcomeDialogHidden: true });
    }
  }, [group, onOpen, shouldBeOpened, updateUIProfileConfig]);

  return { handleClose: onClose, isOpen: isOpened };
};
